import { Injectable } from '@angular/core';
import {ofType, Actions, createEffect} from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { BillService } from '../../../bills/services/bill.service';
import {
    EBillGsmDetailsActions,
    GetBillGsmDetails,
    GetBillGsmDetailsFailure,
    GetBillGsmDetailsSuccess
} from '../actions/bill-gsm-details.actions';
import { AbstractEffects } from '../../abstract.effects';
import { BillGsmDetailsPaginatorInterface } from '../../../bills/models/bill-gsm-details.paginator.interface';

@Injectable()
export class BillGsmDetailsEffects extends AbstractEffects {

    constructor(
        private actions: Actions,
        private billService: BillService,
        public override store: Store<any>
    ) {
        super(store);
    }

    phoneNumber: string;
    month: number;
    filter?: string;
    page: number;
    items: number;

    getBillGsmDetails = createEffect(() => this.actions.pipe(
        ofType<GetBillGsmDetails>(EBillGsmDetailsActions.GetBillGsmDetails),
        tap(params => {
            this.phoneNumber = params.phoneNumber;
            this.month = params.month;
            this.filter = params.filter;
            this.page = params.page;
            this.items = params.items;
        }),
        switchMap(() => this.billService.getBillGsmDetails(this.phoneNumber, this.month, this.page, this.items, this.filter)),
        switchMap((response: BillGsmDetailsPaginatorInterface) => of(new GetBillGsmDetailsSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetBillGsmDetails(this.phoneNumber, this.month, this.page, this.items, this.filter));
            } else {
                this.DisplayMessage('error_with_retry', 400, new GetBillGsmDetailsFailure());
            }
            return throwError(error);
        })
    ));
}
